
import { useI18n } from "vue-i18n";
import { defineComponent, onMounted, ref, watch, nextTick, reactive } from "vue";
import { useRoute } from "vue-router";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import defray from "@/api/defray";
import useClipboard from "vue-clipboard3";
import { resverText, isMobile, isCanSerialize } from "@/utils/index";
import { Field, Button, Cell, CellGroup, CountDown, Toast, Loading, Icon } from "vant";
import { CurrencyList, FiatInfoObject } from "./interface";
import KP_SELECT from "@/components/KP_SELECT.vue";
import KP_INPUT from "@/components/KP_INPUT.vue";
import Types from "./types.vue";
export default defineComponent({
  name: "fiat",
  props: ["type", "info", "showCrypto", "showFiat"],
  emits: ["update:modelValue", "clearRefRate"],
  components: {
    VueQrcode,
    Types,
    KP_SELECT,
    KP_INPUT,
    [Field.name]: Field,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [CountDown.name]: CountDown,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Icon.name]: Icon
  },
  setup(props, ctx) {
    const route = useRoute();
    const { t } = useI18n();
    const dev = process.env.VUE_APP_BUILD_ENV;
    const loaded = ref(false);
    const type = ref(ctx.attrs.modelValue || 0);
    const FormData = reactive({});

    watch(
      () => type.value,
      (a, b) => {
        type.value = a;
        ctx.emit("update:modelValue", a);
      }
    );

    onMounted(() => {
      getOrderDetail();
    });

    const SplitNumber = number => {
      let data = number.toString().split("");
      let n1 = 0,
        n2 = 0;
      if (data.length == 2) {
        n1 = data[0];
        n2 = data[1];
      } else if (data.length == 1) {
        n2 = data[0];
      }
      return [n1, n2];
    };

    const result = ref(<FiatInfoObject>{
      cash_currency_config_list: [],
      crypto_currency_config_list: [],
      amount: 0,
      cancel_url: "",
      currency: "",
      description: "",
      expires_at: "",
      expires_in: 0,
      name: "",
      order_no: "",
      out_order_no: "",
      out_user_id: "",
      out_user_name: "",
      payment_url: "",
      redirect_url: "",
      order_status: "",
      extend: {}
    });

    // @ts-ignore
    const k: string = route.query?.k || "";
    const getOrderDetail = async () => {
      if (k) {
        // const loadingToast = Toast({
        //   message: "",
        //   type: "loading",
        //   overlay: true,
        //   duration: 0,
        //   overlayStyle: {
        //     backgroundColor: "rgba(0, 0, 0, 0)"
        //   }
        // });
        // const res = await defray.getPayIn();
        const res = props.info;
        // loadingToast?.close();
        if (res?.code == 200) {
          result.value = res?.data;
          if (res?.data?.cash_order_detail) {
            ctx.emit("update:modelValue", 1);
            steps.value = 3;
            result.value.extend = Object.assign(
              res?.data?.cash_order_detail || {},
              result.value.extend
            );
            setTimeout(() => {
              getStatus();
            }, 3000);
          } else {
            if (res?.data?.crypto_order_detail) {
              ctx.emit("update:modelValue", 0);
            } else {
              steps.value = 1;
              if (result.value.cash_currency_config_list?.length) {
                setCheckCurrency(result.value.cash_currency_config_list[0]);
              }
            }
          }
        } else {
          res?.msg &&
            Toast({
              message: res?.msg,
              overlay: false,
              duration: 1200
            });
        }
      } else {
        Toast({
          message: t("error"),
          overlay: false,
          duration: 2000
        });
      }
    };

    // 轮询获取状态
    const getStatus = async () => {
      if (k) {
        const res = await defray.getPayIn();
        if (res?.code == 200) {
          result.value.extend = Object.assign(result.value.extend, res?.data?.cash_order_detail);
          loaded.value = true;
          switch (result.value.extend?.order_status) {
            case "PENDING":
              setTimeout(() => {
                getStatus();
              }, 3000);
              break;
            case "SUCCESS":
              setTimeout(() => {
                if (result.value?.redirect_url) {
                  window.location.href = result.value?.redirect_url;
                }
              }, 1000);
              break;
            case "FAIL":
            case "CANCEL":
              result.value?.cancel_url && (window.location.href = result.value?.cancel_url);
              break;
          }
        } else {
          loaded.value = false;
        }
      }
    };

    const { toClipboard } = useClipboard();
    const copy = async (text: string) => {
      try {
        await toClipboard(text);
        Toast({
          message: t("defray.copied"),
          overlay: false,
          duration: 800
        });
      } catch (e) {
        console.error(e);
      }
    };

    // 下一步
    const steps = ref(1);
    const next = () => {
      if (steps.value == 1) {
        if (!checkCurrency.value.currency || !checkPaymentType.value) {
          return;
        }
        getCashierTopUpRequiredFields();
      }
    };

    // 下单
    const createOrder = async () => {
      let empty = false;
      dynamicsFiledList.value.map(x => {
        // @ts-ignore
        if (!FormData[x?.field_name]) {
          empty = true;
        }
      });

      if (empty) {
        return;
      }
      const loadingToast = Toast({
        message: "",
        type: "loading"
      });
      let param = {
        currency: checkCurrency.value.currency,
        payment_type: checkPaymentType.value,
        redirect_url: result?.value.redirect_url,
        device: isMobile() ? "mobile" : "pc"
      };
      dynamicsFiledList.value.map(x => {
        // @ts-ignore
        param[x?.field_name] = FormData[x?.field_name].trim();
      });
      const res = await defray.postFiatPayIn(param);
      loadingToast?.close();
      if (res?.code == 200) {
        result.value.extend = res?.data?.cash_order_detail || {};
        steps.value = 3;
        switch (result.value.extend.action_type) {
          case "REDIRECT":
            window.open(result.value?.extend?.checkout_url, "_blank");
            break;
        }
        getStatus();
        ctx.emit("clearRefRate");
      } else {
        res?.message &&
          Toast({
            message: res?.message,
            overlay: false,
            duration: 4000
          });
      }
    };

    // 倒计时结束
    const isFinish = ref(false);
    const finish = () => {
      isFinish.value = true;
    };

    // 选择币种
    const checkCurrency = ref(<CurrencyList>{});
    const setCheckCurrency = item => {
      checkCurrency.value = item;
      if (item?.payment_type_list.length) {
        setcheckPaymentType(item?.payment_type_list[0]);
      }
    };
    const checkPaymentType = ref("");
    const setcheckPaymentType = value => {
      checkPaymentType.value = value;
    };

    // 动态表单
    const dynamicsFiledList = ref([]);
    const getCashierTopUpRequiredFields = async () => {
      const loadingToast = Toast({
        message: "",
        type: "loading",
        overlay: true,
        overlayStyle: {
          backgroundColor: "rgba(0, 0, 0, 0)"
        },
        duration: 0
      });
      const res = await defray.getTopUpRequiredFields({
        currency: checkCurrency.value.currency,
        payment_type: checkPaymentType.value
      });
      loadingToast.close();
      if (res?.code == 200) {
        const temp = res?.data || [];
        const list = temp.filter(
          x => !["redirect_url", "user_ip", "device"].includes(x?.field_name)
        );
        // Pre-sort "Supplier" and "BankCode" field
        list.unshift(
          ...list.splice(
            // @ts-ignore
            list.findIndex(item => ["bank_code", "supplier"].includes(item?.field_name)),
            1
          )
        );
        dynamicsFiledList.value = list;
        dynamicsFiledList.value.map(x => {
          // @ts-ignore
          FormData[x?.field_name] = "";
        });
        if (dynamicsFiledList.value.length) {
          steps.value = 2;
        } else {
          createOrder();
        }
      } else {
        res?.message &&
          Toast({
            message: res?.message,
            overlay: false,
            duration: 2000
          });
      }
    };

    let extendFieleds = [];
    const onSelectChange = val => {
      if (val.fieldName.includes("bank")) {
        return;
      }

      const childs =
        val.list.find(x => {
          return x.key == val.value.key;
        })?.childs || [];

      extendFieleds.map(x => {
        // @ts-ignore
        FormData[x] = "";
        delete FormData[x];
        dynamicsFiledList.value.splice(
          // @ts-ignore
          dynamicsFiledList.value.findIndex(f => f?.key == val.value.key),
          1
        );
      });

      nextTick(() => {
        extendFieleds = [];
        childs.map(x => {
          FormData[x?.field_name] = "";
          // @ts-ignore
          dynamicsFiledList.value.push(x);
        });
        extendFieleds = childs.map(x => {
          return x.field_name;
        });
      });
    };

    // 重定向
    const redirect = () => {
      window.location.href = result?.value?.redirect_url;
    };

    // 去支付
    const toPayment = () => {
      window.open(result?.value?.extend?.checkout_url, "_blank");
    };

    // 取消付款
    const cancelPayment = () => {
      window.location.href = result?.value.cancel_url;
    };

    return {
      dev,
      resverText,
      isCanSerialize,
      type,
      steps,
      SplitNumber,
      copy,
      loaded,

      result,
      isFinish,
      finish,

      checkCurrency,
      setCheckCurrency,
      checkPaymentType,
      setcheckPaymentType,
      createOrder,

      cancelPayment,

      onSelectChange,
      dynamicsFiledList,
      FormData,

      next,
      redirect,
      toPayment
    };
  }
});
